import React from "react";
import PropTypes from "prop-types";
import RegionalDesktop from "./RegionalDesktop";

function PositivacaoCategory({ app, config }) {
  return <RegionalDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
